import { Action } from '@ngrx/store';

import { SamplingSuppliesCategory } from '../../model/sampling-supply-category.model';
import { CatalogueItem } from '../../model/catalogue-category/catalogue-item.model';

export const LOAD_CATEGORIES = '[SAMPLING_ITEMS] LOAD_CATEGORIES';
export const LOAD_CATEGORIES_SUCCESS = '[SAMPLING_ITEMS] LOAD_CATEGORIES_SUCCESS';
export const LOAD_CATEGORIES_FAIL = '[SAMPLING_ITEMS] LOAD_CATEGORIES_FAIL';
export const LOAD_CATALOGUE_ITEMS = '[SAMPLING_ITEMS] LOAD_CATALOGUE_ITEMS';
export const ADD_CATALOGUE_ITEMS = '[SAMPLING_ITEMS] ADD_CATALOGUE_ITEMS';
export const ADD_LOADED_CATEGORY_ID = '[SAMPLING_ITEMS] ADD_LOADED_CATEGORY_ID';
export const LOAD_CATALOGUE_ITEMS_FAIL = '[SAMPLING_ITEMS] LOAD_CATALOGUE_ITEMS_FAIL';
export const LOAD_CATALOGUE_ITEMS_SUCCESS = '[SAMPLING_ITEMS] LOAD_CATALOGUE_ITEMS_SUCCESS';

export class LoadCategories implements Action {
    readonly type = LOAD_CATEGORIES;

    constructor() {
    }
}

export class LoadCategoriesSuccess implements Action {
    readonly type = LOAD_CATEGORIES_SUCCESS;

    constructor(public categories: SamplingSuppliesCategory[]) {
    }
}

export class LoadCategoriesFail implements Action {
    readonly type = LOAD_CATEGORIES_FAIL;

    constructor() {
    }
}

export class LoadCatalogueItems implements Action {
    readonly type = LOAD_CATALOGUE_ITEMS;

    constructor(public categoryId: number) {
    }
}

export class AddCatalogueItems implements Action {
    readonly type = ADD_CATALOGUE_ITEMS;

    constructor(public catalogueItems: CatalogueItem[]) {
    }
}

export class AddLoadedCategoryId implements Action {
    readonly type = ADD_LOADED_CATEGORY_ID;

    constructor(public categoryId: number) {
    }
}

export class LoadCatalogueItemsFail implements Action {
    readonly type = LOAD_CATALOGUE_ITEMS_FAIL;

    constructor(public categoryId: number) {
    }
}

export class LoadCatalogueItemsSuccess implements Action {
    readonly type = LOAD_CATALOGUE_ITEMS_SUCCESS;

    constructor(public categoryId: number, public itemIds: number[]) {
    }
}


export type SamplingSuppliesActions = LoadCategories | LoadCategoriesFail |
LoadCategoriesSuccess | LoadCatalogueItems | AddCatalogueItems |
AddLoadedCategoryId | LoadCatalogueItemsFail | LoadCatalogueItemsSuccess;
